import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;

export default function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
  // "screen and" matters: without a media type, this also matches during
  // print rendering, where Chrome's print layout pass can transiently
  // report a narrow viewport width and flip isMobile — which on
  // /admin/print unmounts PrintableMasterGrid mid-print and remounts it
  // with default state once printing ends, discarding the user's margins.
  const query = `screen and (max-width: ${breakpoint - 1}px)`;
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return isMobile;
}
